"use strict";

exports.__esModule = true;
exports.ScrollableMetricChartBody = void 0;
var _react = _interopRequireDefault(require("react"));
var _Axis = require("../../../Charts/Axis");
var _TimeContext = require("../../../Time/TimeContext");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ScrollableMetricChartBody = exports.ScrollableMetricChartBody = /*#__PURE__*/_react["default"].memo(function (props) {
  var width = props.width,
    height = props.height,
    bars = props.bars,
    hideXAxis = props.hideXAxis,
    xAxisHeight = props.xAxisHeight,
    padding = props.padding,
    xScale = props.xScale,
    tickXFormat = props.tickXFormat,
    yAxisHeight = props.yAxisHeight,
    axisFormatter = props.axisFormatter;
  var time = _react["default"].useContext(_TimeContext.TimeContext);
  return /*#__PURE__*/_react["default"].createElement("svg", {
    "data-id": "scrollable-metric-chart-main-content-test-id",
    id: "chart-main-content",
    width: width,
    height: height + padding
  }, bars, !hideXAxis && /*#__PURE__*/_react["default"].createElement(_Axis.Axis, {
    "data-testid": "XAxis",
    x: 0,
    y: yAxisHeight + padding - 1,
    padding: padding,
    height: xAxisHeight,
    width: width,
    scale: xScale,
    orientation: "BOTTOM",
    tickFormat: tickXFormat({
      scale: xScale,
      width: width,
      timezone: time.timezone
    }),
    axisFormatter: axisFormatter ? axisFormatter({
      scale: xScale
    }) : null
  }));
});